import React from "react";
import CustomDropdown from "../../../components/presentationals/CustomDropdown";
import Spinner from "../../../components/presentationals/Spinner";
import AtpOuter from "./atpOuterTable/index";

const ATPDashboardViews = (props) => {
  const {
    isDataLoading,
    timestampArr,
    dropDownOptions,
    changeHandler,
    selectedFSE,
    selectedFSEId,
    getATPDash,
    getATPInner,
    showInner,
    setShowInner,
  } = props;
  return (
    <div
      className="whitebox wow fadeInUp sm-5 mb-1"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
    >
      <div className="subtitlebox">
        <div className="subtitleboxChild"> ATP GT PROGRAM </div>
      </div>
      {!isDataLoading ? (
        <div className="container-fluid">
          <div className="row pb-4">
            {/* <div className="col-6 col-sm-8 text-left">
              <strong>Location :</strong>{" "}
              <label data-cy="location"> JC-Ahmedabad 2 (Gujarat) i385 </label>
            </div> */}

            <div className="col-6 col-sm-4 text-left">
              <strong>
                {" "}
                Last Updated On:{" "}
                <label data-cy="last-updated-on">
                  {" "}
                  {timestampArr?.[0]?.tileTimestamp}{" "}
                </label>
              </strong>
            </div>
          </div>

          <div className="row pb-4">
            <div className="col-3 col-sm-1 text-left">
              <strong> FSE: </strong>{" "}
            </div>

            <div className="col-9 col-sm-11 text-left">
              {dropDownOptions.data.length > 0 ? (
                <CustomDropdown
                  name={dropDownOptions.name}
                  data={dropDownOptions.data}
                  loading={false}
                  changeHandler={(value) => changeHandler(value)}
                  value={selectedFSE}
                />
              ) : (
                <CustomDropdown
                  name={dropDownOptions.name}
                  data={[]}
                  loading={false}
                  value="No FSE available"
                />
              )}
            </div>

            {selectedFSEId ? (
              <AtpOuter
                getATPDash={getATPDash}
                getATPInner={getATPInner}
                showInner={showInner}
                setShowInner={setShowInner}
                selectedFSEId={selectedFSEId}
              />
            ) : (
              <p>No data available</p>
            )}
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default ATPDashboardViews;
